import { Check, ArrowRight, Info } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Pricing = ({ t }) => {
  const scrollToContact = () => {
    document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="precos" data-testid="pricing-section" className="section-darker py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-16 md:mb-24">
          <span className="text-sm tracking-[0.3em] uppercase text-[#C5A059] block mb-4">{t.pricing.badge}</span>
          <h2 data-testid="pricing-title" className="text-4xl md:text-5xl font-medium tracking-tight text-[#E5E5E5] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t.pricing.title} <span className="text-gold-gradient">{t.pricing.highlight}</span>
          </h2>
          <p className="text-[#A3A3A3] text-lg max-w-2xl mx-auto">{t.pricing.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div data-testid="pricing-card" className="pricing-highlight glass-card p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[radial-gradient(circle_at_center,rgba(197,160,89,0.1)_0%,transparent_70%)] pointer-events-none" />
            <div className="relative z-10">
              <div className="inline-block px-4 py-1 bg-[#C5A059]/10 border border-[#C5A059]/30 mb-8">
                <span className="text-xs tracking-widest uppercase text-[#C5A059]">{t.pricing.cardBadge}</span>
              </div>
              <div className="mb-8">
                <span className="text-sm text-[#A3A3A3]">{t.pricing.priceFrom}</span>
                <p className="text-6xl md:text-7xl font-medium text-[#E5E5E5]" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="pricing-value">€1200</p>
                <p className="text-[#A3A3A3] mt-2">{t.pricing.priceNote}</p>
              </div>
              <div className="border-t border-white/10 pt-8 mb-8">
                <p className="text-sm tracking-widest uppercase text-[#A3A3A3] mb-6">{t.pricing.includedTitle}</p>
                <ul className="grid md:grid-cols-2 gap-4">
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[0]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[1]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[2]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[3]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[4]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[5]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[6]}</span>
                  </li>
                  <li className="flex items-start gap-3 text-[#E5E5E5]">
                    <div className="w-5 h-5 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 mt-0.5"><Check className="w-3 h-3 text-[#C5A059]" /></div>
                    <span className="text-sm">{t.pricing.features[7]}</span>
                  </li>
                </ul>
              </div>
              <Button onClick={scrollToContact} data-testid="pricing-cta-button" className="btn-gold w-full bg-[#C5A059] text-[#050505] hover:bg-[#D4B068] py-6 text-base tracking-widest uppercase font-medium group">
                {t.pricing.ctaBtn} <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Button>
              <p className="text-center text-xs text-[#A3A3A3] mt-6">{t.pricing.disclaimer}</p>
            </div>
          </div>
        </div>

        <div className="mt-16 max-w-3xl mx-auto">
          <div className="glass-card p-8 border border-white/5">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-10 h-10 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0">
                <Info className="w-5 h-5 text-[#C5A059]" />
              </div>
              <div>
                <h3 className="text-xl font-medium text-[#E5E5E5] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{t.pricing.maintTitle}</h3>
                <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.pricing.maintDesc}</p>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-white/5 p-6 border-l-2 border-[#C5A059]">
                <p className="text-2xl font-medium text-[#C5A059] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{t.pricing.hosting.price}</p>
                <p className="text-sm text-[#E5E5E5] mb-2">{t.pricing.hosting.title}</p>
                <p className="text-xs text-[#A3A3A3] leading-relaxed">{t.pricing.hosting.desc}</p>
              </div>
              <div className="bg-white/5 p-6 border-l-2 border-[#C5A059]/50">
                <p className="text-2xl font-medium text-[#C5A059] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{t.pricing.changes.price}</p>
                <p className="text-sm text-[#E5E5E5] mb-2">{t.pricing.changes.title}</p>
                <p className="text-xs text-[#A3A3A3] leading-relaxed">{t.pricing.changes.desc}</p>
              </div>
            </div>
            <p className="text-xs text-[#666] mt-6 text-center">{t.pricing.hostingNote}</p>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8 text-center max-w-2xl mx-auto">
          <div>
            <p className="text-2xl font-medium text-[#C5A059] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>50%</p>
            <p className="text-sm text-[#A3A3A3]">{t.pricing.deposit}</p>
          </div>
          <div>
            <p className="text-2xl font-medium text-[#C5A059] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>∞</p>
            <p className="text-sm text-[#A3A3A3]">{t.pricing.revisions}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
